import CONSTANTS from "../../assets/js/Constants"

// import { createBrowserHistory } from 'history'

// const history = createBrowserHistory({
//     forceRefresh: true, // Set true to force full page refreshes
// })

const transportations = {}
export default function (state = transportations, { type, payload }) {
   switch (type) {
      case CONSTANTS.ACTION.TRANSPORTATION.GET_ALL_TRANSPORTATION_OF_ACCOUNT:
         return { ...payload }
      case CONSTANTS.ACTION.TRANSPORTATION.UPDATE_TRANSPORTATIONS:
         return { ...state, data: [...state.data.filter((item) => item.vehicle_id !== payload.vehicle_id)] }

      case CONSTANTS.ACTION.TRANSPORTATION.SET_CURRENT_TRANSPORTATION:
         return { ...state, currentTransportation: { ...state.currentTransportation } }

      case CONSTANTS.ACTION.TRANSPORTATION.UPDATE_ROW_CURRENT_TRANSPORTATION:
         return { ...state, total_row: payload }

      case CONSTANTS.ACTION.TRANSPORTATION.UPDATE_CURRENT_TRANSPORTATION:
         return { ...state, currentTransportation: { ...state.currentTransportation, ...payload } }

      case CONSTANTS.ACTION.TRANSPORTATION.UPDATE_CURRENT_TRANSPORTATION_WITH_TYPE:
         return { ...state, ...payload }

      case CONSTANTS.ACTION.TRANSPORTATION.UPDATE_TRANSPORTATION_INFOMATION:
      case CONSTANTS.ACTION.TRANSPORTATION.POST_TRANSPORTATION_INFOMATION:
         return { ...state, currentTransportation: { ...state.currentTransportation, ...payload } }

      // REGISTRATION_PAPER
      case CONSTANTS.ACTION.REGISTRATION_PAPER.GET_REGISTRATION_PAPER:
         return { ...state, currentTransportation: { ...state.currentTransportation, documentsRegistrationPaper: { ...payload } } }

      case CONSTANTS.ACTION.REGISTRATION_PAPER.ADD_REGISTRATION_PAPER:
         if (state.currentTransportation.documentsRegistrationPaper) {
            if (!Array.isArray(state.currentTransportation.documentsRegistrationPaper.data)) state.currentTransportation.documentsRegistrationPaper.data = []
         } else state.currentTransportation.documentsRegistrationPaper = { data: [] }
         return {
            ...state,
            currentTransportation: {
               ...state.currentTransportation,
               documentsRegistrationPaper: {
                  ...state.currentTransportation.documentsRegistrationPaper,
                  data: [...state.currentTransportation.documentsRegistrationPaper.data, payload]
               }
            }
         }
      // INSURANCE_PAPER
      case CONSTANTS.ACTION.INSURANCE_PAPER.GET_INSURANCE_PAPER:
         return { ...state, currentTransportation: { ...state.currentTransportation, documentsInsurancePaper: { ...payload } } }

      case CONSTANTS.ACTION.INSURANCE_PAPER.ADD_INSURANCE_PAPER:
         if (state.currentTransportation.documentsInsurancePaper) {
            if (!Array.isArray(state.currentTransportation.documentsInsurancePaper.data)) state.currentTransportation.documentsInsurancePaper.data = []
         } else state.currentTransportation.documentsInsurancePaper = { data: [] }
         return {
            ...state,
            currentTransportation: {
               ...state.currentTransportation,
               documentsInsurancePaper: {
                  ...state.currentTransportation.documentsInsurancePaper,
                  data: [...state.currentTransportation.documentsInsurancePaper.data, payload]
               }
            }
         }

      // CAR_BADGES
      case CONSTANTS.ACTION.CAR_BADGES_PAPER.GET_CAR_BADGES_PAPER:
         return { ...state, currentTransportation: { ...state.currentTransportation, documentsCarBadgesPaper: { ...payload } } }

      case CONSTANTS.ACTION.CAR_BADGES_PAPER.ADD_CAR_BADGES_PAPER:
         if (state.currentTransportation.documentsCarBadgesPaper) {
            if (!Array.isArray(state.currentTransportation.documentsCarBadgesPaper.data)) state.currentTransportation.documentsCarBadgesPaper.data = []
         } else state.currentTransportation.documentsCarBadgesPaper = { data: [] }
         return {
            ...state,
            currentTransportation: {
               ...state.currentTransportation,
               documentsCarBadgesPaper: {
                  ...state.currentTransportation.documentsCarBadgesPaper,
                  data: [...state.currentTransportation.documentsCarBadgesPaper.data, payload]
               }
            }
         }
      // RegistrationCard
      case CONSTANTS.ACTION.REGISTRATION_CARD_PAPER.GET_REGISTRATION_CARD_PAPER:
         return { ...state, currentTransportation: { ...state.currentTransportation, documentsRegistrationCardPaper: { ...payload } } }

      case CONSTANTS.ACTION.REGISTRATION_CARD_PAPER.ADD_REGISTRATION_CARD_PAPER:
         if (state.currentTransportation.documentsRegistrationCardPaper) {
            if (!Array.isArray(state.currentTransportation.documentsRegistrationCardPaper.data))
               state.currentTransportation.documentsRegistrationCardPaper.data = []
         } else state.currentTransportation.documentsRegistrationCardPaper = { data: [] }
         return {
            ...state,
            currentTransportation: {
               ...state.currentTransportation,
               documentsRegistrationCardPaper: {
                  ...state.currentTransportation.documentsRegistrationCardPaper,
                  data: [...state.currentTransportation.documentsRegistrationCardPaper.data, payload]
               }
            }
         }

      // Maintenance transportation
      case CONSTANTS.ACTION.MAINTENANCE_TRANSPORTATION.GET_MAINTENANCE_TRANSPORTATION:
         return { ...state, currentTransportation: { ...state.currentTransportation, maintenanceTransportation: { ...payload } } }

      default:
         return { ...state }
   }
}
